import { render, staticRenderFns } from "./livebroadcast.vue?vue&type=template&id=04faef10&scoped=true"
import script from "./livebroadcast.vue?vue&type=script&lang=js"
export * from "./livebroadcast.vue?vue&type=script&lang=js"
import style0 from "./livebroadcast.vue?vue&type=style&index=0&id=04faef10&prod&scoped=true&lang=css"
import style1 from "./livebroadcast.vue?vue&type=style&index=1&id=04faef10&prod&lang=scss&scoped=true"
import style2 from "./livebroadcast.vue?vue&type=style&index=2&id=04faef10&prod&lang=scss&scoped=true"
import style3 from "./livebroadcast.vue?vue&type=style&index=3&id=04faef10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04faef10",
  null
  
)

export default component.exports